export const SERVICE_CREATE = 'serviceCreate'
export const SERVICE_EDIT = 'serviceEdit'
export const SERVICE_DELETE = 'serviceDelete'
export const SERVICE_GET = 'serviceGet'
export const SERVICES_GET = 'servicesGet'
export const SERVICES_BM_GET = 'servicesBMGet'
export const SERVICES_SIMPLE_BM_GET = 'servicesSimpleBMGet'
export const CATEGORIES_GET = 'categoriesGet'
export const SERVICE_SEARCH = 'serviceSearch'
export const SERVICE_ACTIVE = 'serviceActive'
export const SERVICE_INACTIVE = 'serviceInactive'